import React, { useEffect, useState } from "react"
import "./DeletedUsers.scss"
import DeletedApi from "Api/DeletedApi"
import {
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { useNavigate } from "react-router-dom"
import { StandardPagination, StatusBadge, ActionIcon } from "components/Common"

const DeletedUsers = () => {
  document.title = "Deleted Users"

  const accessToken = localStorage.getItem("accessToken")
  const [deletedUsers, setDeletedUsers] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [loading, setLoading] = useState(true)
  const [selectedUser, setSelectedUser] = useState(null)
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)
  const navigate = useNavigate()

  const handleViewUser = user => {
    setSelectedUser(user)
    setIsDetailsModalOpen(true)
  }

  const toggleDetailsModal = () => {
    setIsDetailsModalOpen(!isDetailsModalOpen)
    if (!isDetailsModalOpen) setSelectedUser(null)
  }

  const getAllDeletedUsers = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    DeletedApi.getDeletedUsers(config)
      .then(response => {
        setLoading(false)
        setDeletedUsers(response.data.data || [])
        setTotalRecords(response.data.totalDeletedUser || 0)
      })
      .catch(error => {
        console.log("Error Fetching deleted users", error)
        setLoading(false)
      })
  }

  useEffect(() => {
    getAllDeletedUsers()
  }, [accessToken, page, limit])

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Deleted Users", link: "/deleted-users" },
    { label: "Deleted Users" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const totalPages = Math.ceil(totalRecords / limit)

  const formatDate = dateString => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  return (
    <div className="deleted-users-container">
      <Row>
        <Col xs="12">
          <div className="deleted-users-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Deleted Users"
              handleClick={handleBreadcrumbClick}
            />
          </div>
          <div className="data-table-container">
            <div className="table-responsive mt-4 mb-3">
              {loading ? (
                <DataTableLoader cols={7} />
              ) : (
                <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>User Type</th>
                    <th>Deleted Reason</th>
                    <th>Deleted By</th>
                    <th>Deleted On</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedUsers &&
                    deletedUsers.map((user, index) => (
                      <tr key={user._id} className="deleted-users-table-row">
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>{user.userName}</td>
                        <td>{user.email}</td>
                        <td className="text-capitalize">{user.userType}</td>
                        <td>{user.deletedReason}</td>
                        <td>{user.deletedBy?.userName || "-"}</td>
                        <td>{formatDate(user.deletedOn)}</td>
                        <td>
                          <ActionIcon
                            type="view"
                            onClick={() => handleViewUser(user)}
                            tooltip="View User"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
                </Table>
              )}
            </div>
          </div>
          <StandardPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
          <Modal
            isOpen={isDetailsModalOpen}
            toggle={toggleDetailsModal}
            size="xl"
          >
              <ModalHeader toggle={toggleDetailsModal}>
                User Details
              </ModalHeader>
              <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
                {selectedUser && (
                  <Card>
                    <CardBody>
                      <div className="user-details">
                        <h5 className="mb-4">User Information</h5>
                        <Row className="mb-3">
                          <Col md={6}>
                            <p>
                              <strong>User ID:</strong> {selectedUser.userId}
                            </p>
                            <p>
                              <strong>Username:</strong> {selectedUser.userName}
                            </p>
                            <p>
                              <strong>User Type:</strong>{" "}
                              {selectedUser.userType}
                            </p>
                            <p>
                              <strong>Email:</strong> {selectedUser.email}
                            </p>
                            <p>
                              <strong>Phone:</strong> {selectedUser.phoneNumber}
                            </p>
                          </Col>
                        </Row>

                        <h5 className="mb-4">Deletion Information</h5>
                        <Row>
                          <Col md={12}>
                            <p>
                              <strong>Deleted By:</strong>{" "}
                              {selectedUser.deletedBy?.userName || "-"}
                            </p>
                            <p>
                              <strong>Deleted On:</strong>{" "}
                              {formatDate(selectedUser.deletedOn)}
                            </p>
                            <p>
                              <strong>Deletion Reason:</strong>{" "}
                              {selectedUser.deletedReason || "-"}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                )}
              </ModalBody>
            </Modal>
        </Col>
      </Row>
    </div>
  )
}

export default DeletedUsers
